import { UserProfile } from "../../../application/UserProfile";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  UserDetailTabsServiceProvider,
  vsProviderName as UserDetailTabsServiceProviderName,
} from "../../../user/pages/user";

import { vsComponentName as userPropertyComponentName } from "../user/component";

userPropertyComponentConfig.$inject = [UserDetailTabsServiceProviderName];
export function userPropertyComponentConfig(
  userDetailTabsServiceProvider: UserDetailTabsServiceProvider
) {
  userDetailTabsServiceProvider.addElement({
    displayName: "Properties",
    id: "properties",
    requiredPermission: "userModify",
    uiSrefFragment: "properties",
    stateDefinition: {
      component: userPropertyComponentName,
      url: "/properties",
      resolve: {
        properties: [
          ServerUtilityName,
          (serverUtility: ServerUtility) =>
            serverUtility.fetchAll({
              url: "/api/properties",
              query: { OrderBy: "Name" },
            }),
        ],
        userProperties: [
          "user",
          ServerUtilityName,
          (user: UserProfile, serverUtility: ServerUtility) =>
            serverUtility.fetchAll({
              url: "/api/user/properties",
              query: {
                UserAuthId: user.UserAuthId,
              },
            }),
        ],
      },
    },
  });
}
